module.exports = __webpack_public_path__ + "reports.da482eae3013427065f6";


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend/src/assets/img/admin/reports.jpg
// module id = ../../../../../src/assets/img/admin/reports.jpg
// module chunks = main